// extracted by mini-css-extract-plugin
module.exports = {"action":"action__V26Aj1M0iKFdr","actions":"actions__e6nN+mRzfujkq","icon":"icon__cHvgg1ru6CSiO"};